// extracted by mini-css-extract-plugin
export default {"imageArticle":"index_imageArticle_2qxKv","image":"index_image_B2jud","textPart":"index_textPart_vauZI"};